<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Nunito", sans-serif !important;
  font-size: 14px;

  .compact-form {
    transform: scale(0.675);
    transform-origin: left;
  }
}

.btn {
  cursor: pointer;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 0.95rem !important;
}
</style>
